// extracted by css-extract-rspack-plugin
export default {"SidebarHeader":"anQPp","SidebarContentBordered":"bMYQf","SelectedClickBehaviorItemIcon":"dnYlm","Heading":"S8nY5"};